angular.module('leanlaw')
// MM/dd/yy or TODO locale-specific
.filter("dateStandard", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "MM/dd/yy");
  };
}]).filter("dateStandardLong", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "MM/dd/yyyy");
  };
}]).filter("dateLogical", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "yyyy-MM-dd");
  };
}])
// TODO Make this locale-specific
.filter("dateShort", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "MM/dd");
  };
}]).filter("datePretty", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "MMM dd, yyyy");
  };
}]).filter("dateShortPretty", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "MMM dd");
  };
}]).filter("dateTimePretty", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "MMM dd HH:mm a");
  };
}]).filter("timeStandard", ["$filter", function ($filter) {
  return function (date) {
    return $filter("date")(date, "h:mm a");
  };
}]).filter('hourMeridiem', function () {
  return function (input, scope) {
    if (input) {
      //console.log(input);
      var date = new Date(input);
      var meridiem = "AM";
      var hours = date.getHours();
      var minutes = date.getMinutes();
      if (minutes < 10) minutes = "0" + minutes;
      if (hours >= 12) {
        hours = hours - 12;
        meridiem = "PM";
      }
      if (hours == 0) {
        hours = 12;
      }
      return hours + ":" + minutes + " " + meridiem;
    }
  };
});